"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHasPermission = useHasPermission;
var permission_1 = require("../features/apis/permission");
var hooks_1 = require("../store/hooks");
/** Uses the API's effective grants so role defaults, overrides and administrator access agree with server authorization. */
function useHasPermission(permission) {
    var _a, _b, _c;
    var authUser = (0, hooks_1.useAppSelector)(function (state) { return state.user.user; });
    var _d = (0, permission_1.useGetEffectivePermissionsQuery)("".concat((_a = authUser === null || authUser === void 0 ? void 0 : authUser._uid) !== null && _a !== void 0 ? _a : "", ":").concat((_b = authUser === null || authUser === void 0 ? void 0 : authUser.client) !== null && _b !== void 0 ? _b : ""), {
        skip: !authUser,
        refetchOnMountOrArgChange: true,
    }), currentData = _d.currentData, isFetching = _d.isFetching, isError = _d.isError;
    return !!authUser && !isFetching && !isError && (currentData === null || currentData === void 0 ? void 0 : currentData.success) === true && ((_c = currentData.content) === null || _c === void 0 ? void 0 : _c[permission]) === true;
}
